import { Box, Flex, Heading, Text, List } from '@chakra-ui/react';
import { useTranslate } from '@tolgee/react';

interface SectionData {
  id: string,
  code: string,
  name: string,
}

export default function UnassignedSectionAlert({ menuSections }: {menuSections: SectionData[]}) {
  const { t } = useTranslate();

  if (menuSections.length == 0) {
    return null;
  }

  return (
    <Box rounded="md" bg="yellow.50" border="1px solid" borderColor={'yellow.500'} p={4}>
      <Flex>
        <Box ml={3} flex="1">
          <Heading as="h4" fontSize="md" fontWeight="semibold" color="yellow.800">
            {t('menu.section.unassigned.title', 'Unassigned Sections')}
          </Heading>
          <Text mt={1} fontSize="sm" color="yellow.800">
            {t('menu.section.unassigned.description', 'The following sections have not been assigned:')}
          </Text>
          <List.Root mt={2} gap={1}>
            {menuSections.map((section) => (
              <List.Item key={section.id} fontSize="sm" color="yellow.800">
                • {section.name}
              </List.Item>
            ))}
          </List.Root>
        </Box>
      </Flex>
    </Box>
  );
} 